import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type QuotedIconProps = Omit<BaseIconProps, 'children' | 'hasLegacyStrokeStyles'>;

export const QuotedIcon = ({ ...props }: QuotedIconProps) => (
  <BaseIcon width="14" height="18" viewBox="0 0 14 18" fill="none" {...props}>
    <>
      <path d="M10.7072 7.70711C11.0977 7.31658 11.0977 6.68342 10.7072 6.29289C10.3167 5.90237 9.6835 5.90237 9.29297 6.29289L6.00006 9.5858L4.70709 8.29288C4.31656 7.90236 3.6834 7.90238 3.29288 8.29291C2.90236 8.68344 2.90238 9.3166 3.29291 9.70712L5.29299 11.7071C5.68351 12.0976 6.31667 12.0976 6.70719 11.7071L10.7072 7.70711Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 0C0.447715 0 0 0.447715 0 1V17C0 17.5523 0.447715 18 1 18H13C13.5523 18 14 17.5523 14 17V5C14 4.73478 13.8946 4.48043 13.7071 4.29289L9.70711 0.292893C9.51957 0.105357 9.26522 0 9 0H1ZM2 16V2H8.58579L12 5.41421V16H2Z"
      />
    </>
  </BaseIcon>
);

QuotedIcon.displayName = 'QuotedIcon';
